import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ExitConfirmationService } from '../../../services/exit-confirmation/exit-confirmation.service';
import { NavigationLibraryService } from '../../../services/navigation/navigation.service';
import { MatDialogRef } from '@angular/material/dialog';

declare const tizen: any;

@Component({
  selector: 'app-exit-page',
  templateUrl: './exit-page.component.html',
  styleUrls: ['./exit-page.component.scss'],
})
export class ExitPageComponent implements OnChanges {

  @Input() showExitConfirmation: boolean;
  @Output() exitChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  enableDescription = true;

  constructor(
    private navService: NavigationLibraryService,
    private exitService: ExitConfirmationService,
    public dialogRef: MatDialogRef<ExitPageComponent>,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showExitConfirmation && changes.showExitConfirmation.currentValue) {
      this.navService.focusContainer('exit-box', true, 1);
      this.enableDescription = true;
    }
  }

  onButtonFocus() {
    this.enableDescription = false;
  }

  ok(): void {
    this.exitService.closeApp();
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
    const firstlanguagebox = document.querySelector('.cdk-overlay-container')?.getElementsByTagName('app-language')[0];
    this.exitService.closeExitConfirmation();
    if (firstlanguagebox) {
      this.navService.focusContainer('language-box-container', false, 0);
    } else {
      this.navService.focusPage('focusable-container');
    }
  }
}
